import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container:{
        display: 'flex',
        flexDirection: 'column'
    },
    simElement: {
      display: 'flex',
      flexDirection: 'row'
    },
    blue: {
        color: '#0077CC'
    }
}));

export default useStyles;
